'use client';

// react
import React, { useState } from 'react';

// radix
import * as RadixTooltip from '@radix-ui/react-tooltip';
import {
  RadixTooltipArrow,
  RadixTooltipContent,
  TooltipButton,
} from './styled';

/**
 * Tooltip is a component that displays a tooltip on hover.
 */
export const Tooltip = ({
  children,
  content,
  isSimple = true,
}: TooltipProps) => {
  // state
  const [isOpen, setIsOpen] = useState(false);

  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root
        delayDuration={0}
        open={isOpen}
        onOpenChange={setIsOpen}
      >
        <div onClick={() => setIsOpen(true)}>
          <RadixTooltip.Trigger asChild>
            <TooltipButton>{children}</TooltipButton>
          </RadixTooltip.Trigger>
        </div>
        <RadixTooltip.Portal>
          <RadixTooltipContent sideOffset={5} isSimple={isSimple}>
            {content}
            {isSimple && <RadixTooltipArrow />}
          </RadixTooltipContent>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};

interface TooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  isSimple?: boolean;
}

Tooltip.displayName = 'Tooltip';

export default Tooltip;
